import cn from 'bem-cn';

import { Divider, Skeleton, Stack } from '../../UI';

import './PromptInfoStatistics.scss';

const b = cn('prompt-info-statistics');

export const PromptInfoStatisticsSkeleton = () => {
    return (
        <Stack className={b()}>
            <Skeleton className="back-button" variant="circular" width={56} height={56} />
            <Skeleton variant="rounded" width={56} height={56} className={b('counter-skeleton')} />
            <Divider orientation="vertical" />
            <Skeleton variant="rounded" width={56} height={56} className={b('counter-skeleton')} />
        </Stack>
    );
};
